export default __webpack_public_path__ + "static/sale-title-860bfb77350eab8538080e8efae044e9.gif";